export default {
  title: {
    en: 'Review address',
  },
  currentlyShipping: {
    en: 'Currently shipping to:',
  },
  update: {
    en: 'Update address',
  },
}
